import * as Long from "long";
import { IdResource } from "../constants/IdResource";
import { IdTooltipAnchor } from "../features/tooltip";
import { utilTime } from "./utilTime";
var UtilShop = /** @class */ (function () {
    function UtilShop() {
        this.getOfferRewardsTotalGoldAmount = function (resourceData) {
            return resourceData.reduce(function (acc, val) {
                if (val.id === IdResource.Gold) {
                    acc = acc.add(val.amount);
                }
                return acc;
            }, Long.ZERO);
        };
        this.calculateOfferTotalGoldAmount = function (offerReward) {
            return Long.fromValue(offerReward.baseGoldValue)
                .add(offerReward.webBonusGold || Long.ZERO)
                .add(offerReward.subscriptionBonus || Long.ZERO)
                .add(offerReward.primeTimeBonus || Long.ZERO)
                .add(utilShop.getOfferRewardsTotalGoldAmount(offerReward.rewards));
        };
        this.getHCOfferTooltipAnchor = function (index) {
            if (index % 2 === 0) {
                return IdTooltipAnchor.Left;
            }
            return IdTooltipAnchor.Right;
        };
        this.isOfferExpired = function (offer) {
            var secondsLeft = utilTime.secondsLeftTill(offer.duration);
            var isOfferPermanent = offer.duration === -1;
            return secondsLeft < 0 && !isOfferPermanent;
        };
        this.getTotalRewardAmount = function (pacakges) {
            return pacakges
                .map(function (p) {
                if (p.resourceReward && p.resourceReward[0]) {
                    return p.resourceReward[0].amount;
                }
                return 0;
            })
                .reduce(function (prev, next) {
                return prev + next;
            }, 0);
        };
    }
    return UtilShop;
}());
export var utilShop = new UtilShop();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilShop.ts
// module id = 290
// module chunks = 3